import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const KnowledgeBaseModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.66675 6.66667C6.66675 5.19391 7.86066 4 9.33341 4H18.6667C22.3486 4 25.3334 6.98477 25.3334 10.6667V25.3333C25.3334 26.8061 24.1395 28 22.6667 28H9.33341C7.86065 28 6.66675 26.8061 6.66675 25.3333V6.66667Z"
            fill="url(#paint0_linear_1041_280192)"
          />
          <path
            d="M25.3335 10.349C25.3335 10.5244 25.1914 10.6665 25.016 10.6665L21.3335 10.6665C19.8607 10.6665 18.6668 9.4726 18.6668 7.99984L18.6668 4.3173C18.6668 4.14197 18.809 3.99984 18.9843 3.99984C22.4909 3.99984 25.3335 6.84247 25.3335 10.349Z"
            fill="url(#paint1_linear_1041_280192)"
          />
          <path
            d="M9 12.5002C9 12.132 9.29848 11.8335 9.66667 11.8335H19C19.3682 11.8335 19.6667 12.132 19.6667 12.5002C19.6667 12.8684 19.3682 13.1668 19 13.1668H9.66667C9.29848 13.1668 9 12.8684 9 12.5002Z"
            fill="#552500"
          />
          <path
            d="M9 20.166C9 19.7979 9.2984 19.4995 9.6665 19.4995H22.3335C22.7016 19.4995 23 19.7979 23 20.166C23 20.5341 22.7016 20.8325 22.3335 20.8325H9.6665C9.2984 20.8325 9 20.5341 9 20.166Z"
            fill="#552500"
          />
          <path
            d="M9 23.999C9 23.6309 9.2984 23.3325 9.6665 23.3325H22.3335C22.7016 23.3325 23 23.6309 23 23.999C23 24.3671 22.7016 24.6655 22.3335 24.6655H9.6665C9.2984 24.6655 9 24.3671 9 23.999Z"
            fill="#552500"
          />
          <path
            d="M9 8.66667C9 8.29848 9.29848 8 9.66667 8H13.6667C14.0349 8 14.3333 8.29848 14.3333 8.66667C14.3333 9.03486 14.0349 9.33333 13.6667 9.33333H9.66667C9.29848 9.33333 9 9.03486 9 8.66667Z"
            fill="#552500"
          />
          <path
            d="M9 16.333C9 15.9649 9.2984 15.6665 9.6665 15.6665H22.3335C22.7016 15.6665 23 15.9649 23 16.333C23 16.7011 22.7016 16.9995 22.3335 16.9995H9.6665C9.2984 16.9995 9 16.7011 9 16.333Z"
            fill="#552500"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1041_280192"
              x1="11.3334"
              y1="10.5455"
              x2="12.5332"
              y2="27.9362"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F79B5C" />
              <stop offset="1" stop-color="#FCFF56" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1041_280192"
              x1="19.3335"
              y1="11.9998"
              x2="25.0377"
              y2="3.1427"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F79B5C" />
              <stop offset="1" stop-color="#FCF557" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default KnowledgeBaseModule;
